/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BillingCountryIndexResponse } from '../types/BillingCountryIndex'

/**
 * GET /billing-countries
 * @see backend/nexus/modules/Billing/Http/Controllers/BillingCountryController.php BillingCountryController::index
 */
export async function billingCountryIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BillingCountryIndexResponse>> {
	return axiosInstance.get('/billing-countries', config)
}
